import { render } from "./app.vue?vue&type=template&id=2799342a"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=2799342a&lang=scss"

import exportComponent from "D:\\f-work\\wishing-tree-web\\front-user-page\\wishing-tree-front\\lin-cms-vue-vue-next\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__